import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "no-results-screen-container"
}
const _hoisted_2 = { class: "form-group mb-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "no-results-screen-divider" }, null, -1)
const _hoisted_4 = { class: "no-results-bottom-links" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "link-text" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "link-text" }
const _hoisted_9 = { class: "link-icon" }
const _hoisted_10 = { class: "link-text" }
const _hoisted_11 = { class: "link-icon" }
const _hoisted_12 = { class: "link-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FuelAnimatedIcon = _resolveComponent("FuelAnimatedIcon")!
  const _component_sc_text = _resolveComponent("sc-text")!
  const _component_Button = _resolveComponent("Button")!
  const _component_sc_image = _resolveComponent("sc-image")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_FuelAnimatedIcon),
        _createVNode(_component_sc_text, {
          class: "no-results-icon-title",
          field: _ctx.fields.IconTitle
        }, null, 8, ["field"]),
        _createVNode(_component_sc_text, {
          class: "no-results-icon-subtitle",
          field: _ctx.fields.IconSubtitle
        }, null, 8, ["field"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Button, {
            class: "btn-new-search",
            text: _ctx.fields.ButtonLabel.value,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.triggerNewSearch()))
          }, null, 8, ["text"])
        ]),
        _hoisted_3,
        _createVNode(_component_sc_text, {
          class: "no-results-bottom-title",
          field: _ctx.fields.BottomSectionTitle
        }, null, 8, ["field"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            href: _ctx.CtaPhoneNumber,
            class: "no-results-icon-link"
          }, [
            _createElementVNode("span", {
              class: "link-icon",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.phoneLinkClick && _ctx.phoneLinkClick(...args)))
            }, [
              _createVNode(_component_sc_image, {
                media: _ctx.fields.FirstLinkIcon
              }, null, 8, ["media"])
            ]),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.phoneNumber), 1)
          ], 8, _hoisted_5),
          _createElementVNode("a", {
            href: _ctx.fields.SecondLinkCTA.value,
            class: "no-results-icon-link"
          }, [
            _createElementVNode("span", {
              class: "link-icon",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.secondLinkRedirect && _ctx.secondLinkRedirect(...args)))
            }, [
              _createVNode(_component_sc_image, {
                media: _ctx.fields.SecondLinkIcon
              }, null, 8, ["media"])
            ]),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.fields.SecondLinkLabel.value), 1)
          ], 8, _hoisted_7),
          _createElementVNode("a", {
            href: "#",
            class: "no-results-icon-link",
            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.triggerChat && _ctx.triggerChat(...args)), ["prevent"]))
          }, [
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_sc_image, {
                media: _ctx.fields.ThirdLinkIcon
              }, null, 8, ["media"])
            ]),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.fields.ThirdLinkLabel.value), 1)
          ]),
          _createElementVNode("a", {
            href: "#",
            class: "no-results-icon-link",
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showZipFlyout && _ctx.showZipFlyout(...args)), ["prevent"]))
          }, [
            _createElementVNode("span", _hoisted_11, [
              _createVNode(_component_sc_image, {
                media: _ctx.fields.FourthLinkIcon
              }, null, 8, ["media"])
            ]),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.fields.FourthLinkLabel.value), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}